/**
 * SI LE QUEDA LA SEGUNDA PARTE DEL PERFIL (el cuestionario largo), EN UN SOLO SITIO.
 *
 * La leen las tres tarjetas de Inicio que le llevan a terminarlo: la del Inicio nuevo, la
 * del teléfono y la del ordenador. Le queda a quien tiene macros personalizados en su plan, o
 * a quien compró el ajuste a medida (que hace el completo igual que un Gold), cuando ya hizo
 * el alta y tiene macros, y todavía no ha enviado el largo.
 *
 * Quien compra el ajuste EN EL ALTA (27-10) no tiene el aviso «Te toca rellenar tu reporte»:
 * su reporte es este cuestionario. Si lo deja a medias, esta tarjeta es lo único que le
 * lleva a terminarlo, así que tiene que salirle en las tres.
 *
 * `conMacrosPersonalizados` es `can('macros_personalizados')` de la pantalla.
 */
export function leQuedaLaSegundaParte(profile, conMacrosPersonalizados) {
    if (!profile) return false;
    return !!((conMacrosPersonalizados || profile.ajuste_a_medida?.cobrado)
        && profile.questionnaire_completed
        && (profile.ajuste_macros_completado || profile.macros_puestos_por_alguien)
        && !profile.questionnaire_nivel1_completed);
}
